import { atom } from "jotai";
import { View, DataSet } from "../../../model/core/Workbook";
import {
  datasetsAtom,
  viewAtom,
} from "../../../model/atoms/WorkbookFocusAtoms";
import { getOwnedDatasetId } from "datasheets/model/logic/viewOwnsDataset";

// Note, these atoms will only work if the current view owns a dataset (e.g. spreadsheet view)

export const currentDatasetIdAtom = atom<string>((get) => {
  const view = get(viewAtom);
  return getOwnedDatasetId(view.config);
});

export const datasetAtom = atom<DataSet, DataSet | ((arg: DataSet) => DataSet)>(
  (get) => {
    const datasets = get(datasetsAtom);
    const datasetId = get(currentDatasetIdAtom);
    return datasets[datasetId];
  },
  (get, set, arg) => {
    const datasets = get(datasetsAtom);
    let dataset;
    if (typeof arg === "function") {
      dataset = arg(get(datasetAtom));
    } else {
      dataset = arg;
    }
    const newDatasets = { ...datasets, ...{ [dataset.id]: dataset } };
    set(datasetsAtom, newDatasets);
  }
);

export type ViewAndDataSet = [View, DataSet];
export const viewWithDatasetAtom = atom<
  ViewAndDataSet,
  ViewAndDataSet | ((arg: ViewAndDataSet) => ViewAndDataSet)
>(
  (get) => {
    return [get(viewAtom), get(datasetAtom)];
  },
  (get, set, arg) => {
    let viewAndDataset;
    if (typeof arg === "function") {
      viewAndDataset = arg(get(viewWithDatasetAtom));
    } else {
      viewAndDataset = arg;
    }
    const [view, dataset] = viewAndDataset;
    set(viewAtom, view);
    set(datasetAtom, dataset);
  }
);

export const propertiesAtom = atom(
  (get) => {
    const dataset = get(datasetAtom);
    return dataset.properties;
  },
  (get, set, arg) => {
    const dataset = get(datasetAtom);
    const prevProperties = dataset.properties;
    let properties;
    if (typeof arg === "function") {
      properties = arg(prevProperties);
    } else {
      properties = arg;
    }
    const newDataset = {
      ...dataset,
      ...{ properties: properties },
    };
    set(datasetAtom, newDataset);
  }
);
